// WebView parameter utilities
export interface WebViewParams {
  k?: string      // API token
  lang?: string   // Language preference
  theme?: string  // Theme preference
}

export class WebViewParamsService {
  private params: WebViewParams = {}
  private static instance: WebViewParamsService

  private constructor() {
    this.extractParams()
  }

  static getInstance(): WebViewParamsService {
    if (!WebViewParamsService.instance) {
      WebViewParamsService.instance = new WebViewParamsService()
    }
    return WebViewParamsService.instance
  }

  private extractParams(): void {
    const urlParams = new URLSearchParams(window.location.search)
    
    this.params = {
      k: urlParams.get('k') || undefined,
      lang: urlParams.get('lang') || 'pt-BR',
      theme: urlParams.get('theme') || 'light',
    }

    console.log('🔍 WebView params extracted:', {
      hasToken: !!this.params.k,
      lang: this.params.lang,
      theme: this.params.theme
    })
  }

  getApiToken(): string | undefined {
    return this.params.k
  }

  getLanguage(): string {
    return this.params.lang || 'pt-BR'
  }

  getTheme(): string {
    return this.params.theme || 'light'
  }

  getAllParams(): WebViewParams {
    return { ...this.params }
  }

  hasApiToken(): boolean {
    return !!this.params.k && this.params.k.trim().length > 0
  }

  // Update params if URL changes (for SPA navigation)
  updateFromCurrentUrl(): void {
    this.extractParams()
  }
}

export const webViewParamsService = WebViewParamsService.getInstance()